import localforage from 'localforage'

// SSR (uses an empty object)
let localCache = {
  async getItem<T>(key: string): Promise<T | null> { return Promise.resolve(null as T) },
  async setItem<T>(key: string, value: T): Promise<T> { return Promise.resolve(null as T) },
  async removeItem<T>(key: string): Promise<void> { return Promise.resolve() },
}

// Browser rendering (uses localStorage mechanism)
export function initLocalCache() {
  localCache = {
    getItem: localforage.getItem,
    setItem: localforage.setItem,
    removeItem: localforage.removeItem,
  }
}

export const getLocalCache = () => localCache
